import React, {Component} from "react";
import ApiService from "../ApiService";
import {IMessageBarHelper} from "../../utils/IMessageBarHelper";
import {PrimaryButton, Toggle} from "office-ui-fabric-react";

export interface BulkFetchDataCardProps {
    apiService: ApiService;
    messageBar: IMessageBarHelper;
}

export interface BulkFetchDataCardState
{
    force: boolean;
    loading: boolean;
}


export class BulkFetchDataCard extends Component<BulkFetchDataCardProps, BulkFetchDataCardState> {

    constructor(props: BulkFetchDataCardProps) {
        super(props);

        this.state = {
            force: false,
            loading: false,
        };
    }

    public async componentDidMount() {
    }

    public componentDidUpdate(prevProps: Readonly<BulkFetchDataCardProps>, prevState: Readonly<BulkFetchDataCardState>, snapshot?: any) {
    }
    
    private start = async () =>
    {
        this.setState({
            loading: true
        });
        
        try
        {
            await this.props.apiService.devBulkFetchArbor(this.state.force);
        }
        catch (e)
        {
            this.props.messageBar.error(`Failed to start, ${e}`);
        }
        
        this.setState({
            loading: false
        });
    }

    public render()
    {
        return (
            <div className={"card"}>

                <div className={"card__header"}>
                    <span className={"card__title"}>Bulk Fetch Data (Arbor direct)</span>
                </div>


                <div className={"card__content"}>
                    <Toggle
                        label={"Force"}
                        inlineLabel={true}
                        checked={this.state.force}
                        onChange={(event, newValue) => {
                            this.setState({
                                force: newValue!
                            });
                        }}
                        role="switch"
                    />

                    <PrimaryButton text="Start" onClick={() => {
                        this.start();
                    }}/>


                </div>

            </div>
        );
    }
}